<div class="one-management-module">
  <div class="management-section">
    
  <router-outlet></router-outlet>
    <!-- <one-user-title-component></one-user-title-component> -->
  </div>
</div>
